import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ToasterService {
    private toastSubject: Subject<{ message: string; type: string }> = new Subject<{ message: string; type: string }>();

    showSuccessToast(message: string) {
        this.toastSubject.next({ message, type: 'success' });
    }

    showErrorToast(message: string) {
        this.toastSubject.next({ message, type: 'error' });
    }

    showWarningToast(message: string) {
        this.toastSubject.next({ message, type: 'warn' });
    }

    getToastMessage() {
        return this.toastSubject.asObservable();
    }
}
